import { render, staticRenderFns } from "./BasePayType.vue?vue&type=template&id=0ecf05e6&scoped=true&"
import script from "./BasePayType.vue?vue&type=script&lang=js&"
export * from "./BasePayType.vue?vue&type=script&lang=js&"
import style0 from "./BasePayType.vue?vue&type=style&index=0&id=0ecf05e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf05e6",
  null
  
)

export default component.exports